import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import _isFunction from 'lodash/isFunction'
import { Map } from 'immutable'
import Button from 'components/Button'
import { getBoundActions } from 'actions'
import {
  upstreamContextOnClick as upstreamContextClick,
  WATCH_BUTTON,
} from 'services/upstream-context'

function WatchV2 (props) {
  const {
    watchAccess,
    isFree,
    staticText,
    url,
    className,
    buttonType,
    iconType,
    text,
    label,
  } = props
  const query = (watchAccess || isFree) ? { fullplayer: 'feature' } : null
  const watchText = staticText.get('watchNow')

  const getClassName = () => {
    const baseClassName = 'watch-v2'
    const classNameArray = [baseClassName]

    if (className) {
      classNameArray.push(className)
    }

    return classNameArray.join(' ')
  }

  const handleClick = (event) => {
    const {
      onClickWatch,
      upstreamContext,
      setUpstreamContext,
    } = props
    let error

    try {
      watchNowGaEvent()

      if (_isFunction(upstreamContextClick)) {
        upstreamContextClick(event, { upstreamContext, setUpstreamContext })
      }
    } catch (e) {
      // Save tracking error to allow onClickWatch to run first
      error = e
    }

    try {
      if (_isFunction(onClickWatch)) {
        onClickWatch()
      }
    } catch (e) {
      // Prefer to send interaction error
      error = e
    }

    if (error) {
      throw error
    }
  }

  const watchNowGaEvent = () => {
    const { upstreamContext = Map(), setDefaultGa4Event } = props

    // GA4 events
    const playClickEventData = Map.isMap(upstreamContext) ? upstreamContext.get('playClickEventData', Map()) : Map()
    if (Map.isMap(playClickEventData) && playClickEventData.size > 0) {
      setDefaultGa4Event(playClickEventData)
    }
  }

  return (
    <Button
      label={label}
      type={buttonType}
      icon={iconType}
      url={url}
      query={query}
      element={WATCH_BUTTON}
      onClick={handleClick}
      className={getClassName()}
    >
      {text || watchText}
    </Button>
  )
}

WatchV2.propTypes = {
  url: PropTypes.string.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  watchAccess: PropTypes.bool.isRequired,
  isFree: PropTypes.bool.isRequired,
  className: PropTypes.string,
  buttonType: PropTypes.string,
  iconType: PropTypes.string,
  staticText: ImmutablePropTypes.map.isRequired,
  upstreamContext: ImmutablePropTypes.map,
  onClickWatch: PropTypes.func,
  text: PropTypes.string,
  setDefaultGa4Event: PropTypes.func,
  label: PropTypes.string,
}

WatchV2.defaultProps = {
  upstreamContext: Map(),
}

const MemoizedWatch = React.memo(WatchV2)
export default connect(
  (state) => {
    return {
      staticText: state.staticText.getIn(['data', 'watchV2', 'data']),
      auth: state.auth,
    }
  },
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setUpstreamContext: actions.upstreamContext.setUpstreamContext,
      setDefaultGa4Event: actions.eventTracking.setDefaultGa4Event,
    }
  },
)(MemoizedWatch)
